import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { PERM_LABEL, PERM_SECTIONS, SECTION_ORDER, type PermKey } from "@/lib/permissions";

/**
 * The nine per-user permission toggles, grouped into the three Flow C/D
 * sections (CHP-296). Shared by the invite dialog's step 2 and the
 * edit-permissions dialog (CHP-322) so both render identical toggles.
 *
 * `idPrefix` keeps the toggle ids stable per host (the invite dialog uses
 * "invite-perm" so its existing tests keep matching).
 */
export function PermissionToggles({
  permissions,
  onChange,
  idPrefix = "perm",
}: {
  permissions: Record<PermKey, boolean>;
  onChange: (key: PermKey, checked: boolean) => void;
  idPrefix?: string;
}) {
  return (
    <>
      {SECTION_ORDER.map((section) => (
        <div key={section} className="space-y-2">
          <h3 className="text-sm font-semibold">{section}</h3>
          <div className="space-y-2 pl-1">
            {PERM_SECTIONS[section].map((permKey) => {
              const inputId = `${idPrefix}-${permKey}`;
              return (
                <div key={permKey} className="flex items-center gap-2">
                  <Switch
                    id={inputId}
                    checked={permissions[permKey]}
                    onCheckedChange={(checked) => onChange(permKey, checked)}
                  />
                  <Label htmlFor={inputId} className="cursor-pointer font-normal">
                    {PERM_LABEL[permKey]}
                  </Label>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
}
